import { useEffect, useState } from 'react';
import { fetchAllCategory } from '../../api/user-profile/user-profile.api';
import { IOption } from '../../select/select.component';
import {
  fetchPostCategoriesApi,
  fetchPublicPostCategoriesApi,
} from '../../api';
import { IPostCategory } from '../../models';
import _ from 'lodash';
import { jwtDecode } from 'jwt-decode';
import { LocalStorageService } from '../../configuration';

interface JwtPayload {
  Role?: string[];
  // ...other fields if needed
}

export const useCategories = ({
  categoryId,
  type,
}: {
  categoryId?: string;
  type: 'post' | 'all';
}) => {
  const [categories, setCategories] = useState<IOption[]>([]);
  const [postCategories, setPostCategories] = useState<IPostCategory[]>([]);

  // Get roles from JWT in localStorage
  let roles: string[] | undefined;
  const token = LocalStorageService.getItem('accessToken');
  if (token) {
    try {
      const decoded = jwtDecode<JwtPayload>(token);
      roles = decoded.Role;
      console.log('roles', roles);
    } catch {
      roles = undefined;
    }
  }
  const fetchCategoryOptions = async () => {
    try {
      // Replace this URL with the actual endpoint from which you're fetching category options
      const response = await fetchAllCategory();
      const data: any[] = response.map((item: any) => ({
        value: item.id,
        label: item.name,
      }));
      setCategories(data);
      // Optionally, update form default values here if necessary
    } catch (error) {
      console.error('Failed to fetch category options:', error);
    }
  };

  const fetchPostCategories = async () => {
    if (!roles || roles.length === 0) {
      const response = await fetchPublicPostCategoriesApi();
      setPostCategories(response as unknown as IPostCategory[]);
    } else {
      const response = await fetchPostCategoriesApi();
      setPostCategories(response as unknown as IPostCategory[]);
    }
  };

  const getCategory = (id: string) => {
    return categories.find((category) => category.value === id);
  };

  const getPostCategory = (id: string) => {
    return _.find(postCategories, (category) => category.id === id);
  };

  useEffect(() => {
    if (type === 'all') {
      fetchCategoryOptions();
    }
    if (type === 'post') {
      fetchPostCategories();
    }
  }, []);

  return {
    categories,
    fetchCategoryOptions,
    getCategory,
    getPostCategory,
    postCategories,
  };
};
